import { request } from '@/shared/api/request'

export const staffBranchConsent = (payload) => {
	return request({ url: '/assessment/staff/branchConsent', method: 'POST', params:  payload})
}